import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M2 16L12 6l10 10" }));
export {
  o as ReactComponent
};
